import { createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "list"
};
const _hoisted_2 = {
  class: "card"
};
const _hoisted_3 = {
  class: "list-wrap"
};
const _hoisted_4 = {
  class: "item"
};
const _hoisted_5 = {
  class: "info"
};
const _hoisted_6 = {
  class: "number"
};
const _hoisted_7 = {
  class: "item"
};
const _hoisted_8 = {
  class: "info"
};
const _hoisted_9 = {
  class: "number"
};
const _hoisted_10 = {
  class: "item"
};
const _hoisted_11 = {
  class: "info"
};
const _hoisted_12 = {
  class: "number"
};
const _hoisted_13 = {
  class: "card"
};
const _hoisted_14 = {
  class: "list-wrap"
};
const _hoisted_15 = {
  class: "item"
};
const _hoisted_16 = {
  class: "info"
};
const _hoisted_17 = {
  class: "number"
};
const _hoisted_18 = {
  class: "item"
};
const _hoisted_19 = {
  class: "info"
};
const _hoisted_20 = {
  class: "number"
};
const _hoisted_21 = {
  class: "item"
};
const _hoisted_22 = {
  class: "info"
};
const _hoisted_23 = {
  class: "number"
};
import { ref, watch } from 'vue';
import CardHeader from './CardHeader.vue';
export default {
  __name: 'BaseData',
  props: {
    baseInfo: {
      type: Object,
      default: () => ({})
    }
  },
  setup(__props) {
    let props = __props;
    let dataInfo = ref({});
    watch(props.baseInfo, newValue => {
      dataInfo.value = newValue;
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(CardHeader, {
        title: "基础数据"
      }), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_image, {
        class: "icon",
        fit: "fill",
        src: require('@/assets/images/screen/base-icon1.png')
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_unref(dataInfo)?.unitNumber), 1), _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "title"
      }, "单位数量", -1))])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_image, {
        class: "icon",
        fit: "fill",
        src: require('@/assets/images/screen/base-icon2.png')
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(_unref(dataInfo)?.dailyActiveNumber), 1), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "title"
      }, "日活跃数量", -1))])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_image, {
        class: "icon",
        fit: "fill",
        src: require('@/assets/images/screen/base-icon3.png')
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(_unref(dataInfo)?.monthlyActiveNumber), 1), _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "title"
      }, "月活跃数量", -1))])])])]), _createElementVNode("div", _hoisted_13, [_createVNode(CardHeader, {
        title: "食谱数据"
      }), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_image, {
        class: "icon",
        fit: "fill",
        src: require('@/assets/images/screen/food-icon1.png')
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(_unref(dataInfo)?.goodsNumber), 1), _cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "title"
      }, "商品数量", -1))])]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_el_image, {
        class: "icon",
        fit: "fill",
        src: require('@/assets/images/screen/food-icon2.png')
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString(_unref(dataInfo)?.recipeNumber), 1), _cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "title"
      }, "菜谱数量", -1))])]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_el_image, {
        class: "icon",
        fit: "fill",
        src: require('@/assets/images/screen/food-icon3.png')
      }, null, 8, ["src"]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(_unref(dataInfo)?.setMealNumber), 1), _cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "title"
      }, "套餐数量", -1))])])])])]);
    };
  }
};